import type { SVGProps } from 'react'

export const SvgCreditCard = (props: SVGProps<SVGSVGElement>) => (
	<svg
		height='1em'
		viewBox='0 0 576 512'
		width='1em'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
	>
		<path
			d='M64 64c-17.7 0-32 14.3-32 32v32h512V96c0-17.7-14.3-32-32-32H64zm-32 96v64h512v-64H32zm0 96v160c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V256H32zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 272c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z'
			fill='currentColor'
		/>
	</svg>
)
